import DiscountCodeVCContainer from './DiscountCodeVCContainer';

export default DiscountCodeVCContainer;
